import { coreExtensionData } from '@backstage/frontend-plugin-api';
import apiDocsAlphaPlugin from '@backstage/plugin-api-docs/alpha';
import type { UserListFilterKind } from '@backstage/plugin-catalog-react';
import { PersistedUserListFilterElement } from '../../components/userListFilter/persistedUserListFilter';

// PAT-1022: `/api-docs` is the page of `@backstage/plugin-api-docs/alpha`. Its
// `initiallySelectedFilter` is static extension config, so on its own it cannot
// restore the Owned / Starred / All choice the user made last (stored in
// localStorage by `UserListFilterPersister`), which the legacy route did by
// re-reading storage on every mount.
//
// This override keeps the upstream page (header, Create button, table) and only
// swaps its element: the original factory is called once per filter, and
// `PersistedUserListFilterElement` picks the stored one on each mount. The
// configured `initiallySelectedFilter` (app-config.yaml) is the fallback when
// nothing valid is stored. A `?filters[user]=` URL param still wins over both,
// as before. Same extension id as the plugin's page, so it replaces it.
export const apiExplorerPageOverride = apiDocsAlphaPlugin
  .getExtension('page:api-docs')
  .override({
    *factory(originalFactory, { config }) {
      const defaultFilter: UserListFilterKind =
        config.initiallySelectedFilter ?? 'all';
      const pageFor = (filter: UserListFilterKind) =>
        originalFactory({
          config: { ...config, initiallySelectedFilter: filter },
        }).get(coreExtensionData.reactElement);

      // Route path, route ref, title and icon do not depend on the filter.
      yield* originalFactory();
      // Same id as the original element, so it replaces it.
      yield coreExtensionData.reactElement(
        <PersistedUserListFilterElement
          defaultFilter={defaultFilter}
          elements={{
            owned: pageFor('owned'),
            starred: pageFor('starred'),
            all: pageFor('all'),
          }}
        />,
      );
    },
  });
